import { cn } from "@newxsystems/shared";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { getTootSectionSpacing } from "../../../../modules/layout/toot-section-spacing";
import { TootMediaFrame } from "../../../../modules/surface/components/TootMediaFrame/TootMediaFrame";
import type { IFullWidthVideoFeatureBlockProps } from "./FullWidthVideoFeatureBlock.props";

export const FullWidthVideoFeatureBlock = ({
  anchorId,
  buttons,
  eyebrow,
  heading,
  parentClass,
  poster,
  spacing,
  subheading,
  video,
}: IFullWidthVideoFeatureBlockProps) => {
  if (!video?.embedUrl) {
    return null;
  }

  const posterImage = poster ?? video.poster;
  const headingId = heading && anchorId ? `${anchorId}-heading` : undefined;
  const hasHeader = Boolean(eyebrow || heading || subheading || buttons?.length);

  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "relative isolate overflow-hidden px-6 md:px-10",
        getTootSectionSpacing(spacing),
        parentClass,
      )}
      id={anchorId ?? undefined}
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8">
        {hasHeader ? (
          <div className="mx-auto flex max-w-3xl flex-col items-center gap-4 text-center">
            <TootHeading
              alignment="center"
              eyebrow={eyebrow}
              heading={heading}
              headingId={headingId}
              subheading={subheading}
            />
            {buttons?.length ? <TootActions actions={buttons} alignment="center" /> : null}
          </div>
        ) : null}

        <TootMediaFrame
          alt={posterImage?.alternateText ?? ""}
          aspectRatio={video.aspectRatio ?? "16 / 9"}
          caption={video.caption ?? undefined}
          className="overflow-hidden rounded-3xl border-toot-grid/90 bg-toot-surface-terminal shadow-2xl"
          embedTitle={video.title}
          focalPoint={posterImage?.focalPoint ?? undefined}
          height={posterImage?.height ?? undefined}
          kind="embed"
          playOnPosterClick={Boolean(posterImage?.defaultSrc)}
          poster={posterImage?.defaultSrc ?? undefined}
          posterAlt={posterImage?.alternateText ?? undefined}
          sizes={posterImage?.sizes ?? undefined}
          src={video.embedUrl}
          srcSet={posterImage?.srcSet ?? undefined}
          width={posterImage?.width ?? undefined}
        />
      </div>
    </section>
  );
};

FullWidthVideoFeatureBlock.displayName = "Block::FullWidthVideoFeatureBlock";
